import { Select } from 'antd'
import { useHistogramConfiguration } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { useDrilldownSchema } from 'features/drilldown/rolodex/DrilldownDataSchema'
import { convertKeyToLabel } from 'features/drilldown/rolodex/ontology/ontologyTypes'
import { FC, useMemo } from 'react'
import { RolodexHistogramAggregationOp } from 'types'

const OPTIONS: ReadonlyArray<{
  value: RolodexHistogramAggregationOp
  label: string
}> = (['count', 'min', 'max', 'sum'] as RolodexHistogramAggregationOp[]).map(
  (op: RolodexHistogramAggregationOp) => ({
    value: op,
    label: convertKeyToLabel(op),
  })
)

export const HistoAggregationOpSelect: FC = () => {
  const { aggregationColumn, aggregationOp, setAggregationOp } =
    useHistogramConfiguration()
  const { fields } = useDrilldownSchema()

  const aggColumnType = fields[aggregationColumn]?.fieldType ?? 'count'

  const options = useMemo(
    () =>
      aggColumnType === 'number'
        ? OPTIONS
        : OPTIONS.filter(({ value }) => value === 'count'),
    [aggColumnType]
  )

  return (
    <Select
      options={[...options]}
      value={aggregationOp}
      onChange={setAggregationOp}
      style={{ width: 225 }}
      disabled={options.length <= 1}
    />
  )
}
